import React from "react";
import { Button } from "@deliverr/ui";
import { ModalTemplate, SoundFx } from "@deliverr/ui-facility";
import { FormattedMessage } from "react-intl";
import { useSortationModal } from "sortation/components/SortationModal";
import { sortationDangerIconProps } from "sortation/components/SortationModal/sortationModalIconProps";
import { DivertLaneModal } from "./DivertLaneModal";

export const InvalidDivertLaneCodeModal: React.FC = () => {
  const { hideModal } = useSortationModal();
  return (
    <ModalTemplate
      title={
        <FormattedMessage
          id="sortation.scanDivertLane.invalidDivertLaneTitle"
          defaultMessage="Invalid divert lane code"
        />
      }
      text={
        <FormattedMessage
          id="sortation.scanDivertLane.invalidDivertLaneBody"
          defaultMessage={"This barcode is unrecognized. Scan again or try another divert lane."}
        />
      }
      iconProps={sortationDangerIconProps}
      soundFx={SoundFx.ERROR_FAST}
      data-testid="invalid_divert_lane_code_modal"
    >
      <Button block onClick={() => hideModal(DivertLaneModal.INVALID_DIVERT_LANE_CODE)}>
        <FormattedMessage id="sortation.scanDivertLane.understandConfirm" defaultMessage="I understand" />
      </Button>
    </ModalTemplate>
  );
};
